export const USER_LABEL_TYPES = Object.freeze({
  MEMBERS: 'Members',
  TRANSPORTATION_PROVIDERS: 'Transportation Providers',
  TRIPS: 'Trips',
  NOTES: 'Notes',
  DOCUMENTS: 'Documents',
  UNIVERSAL: 'Universal',
});

export const USER_LABEL_TYPES_FOR_PAYLOAD = Object.freeze({
  MEMBERS: 'PATIENTS',
  TRANSPORTATION_PROVIDERS: 'TRANSPORTATION_PROVIDER_CONTRACTS',
  TRIPS: 'TRIPS',
  NOTES: 'NOTES',
  DOCUMENTS: 'DOCUMENTS',
  UNIVERSAL: '*',
});

export const USER_LABEL_TYPE_DROPDOWN_OPTIONS = Object.entries(
  USER_LABEL_TYPES_FOR_PAYLOAD,
).map(([key, value]) => ({
  label: USER_LABEL_TYPES[key],
  value,
}));
